import { createContext } from 'react';

/**
 * Карточка документа в правке: поля держат место под строку ошибки (`FormGroup reserveMessage`), ряд не прыгает.
 * Значение ставит каждый `FormBuilder` (`documentCard`), вложенные формы окон его не наследуют.
 */
export const FormMessageReserveContext = createContext(false);
